const shifts = {
  form: {
    information: {
      directionOptions: {
        from: 'From School',
        to: 'To School',
        both: 'To School & From School',
      },
    },
  },
};

export default shifts;
